export function TourPhotoStep(props) {
  const { visible = true, children } = props;

  if (!visible) {
    return null;
  }

  return <>{children}</>;
}

export default TourPhotoStep;
